import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToAnchor - Gère le scroll vers les ancres lors de la navigation
 *
 * Ce composant écoute les changements de route et scroll automatiquement
 * vers l'ancre spécifiée dans l'URL (ex: /#evenements)
 */
const ScrollToAnchor = () => {
  const location = useLocation()

  useEffect(() => {
    // Extraire l'ancre de l'URL (ex: /#evenements -> evenements)
    const hash = location.hash.replace('#', '')
    
    if (hash) {
      // Petit délai pour s'assurer que le DOM est chargé
      setTimeout(() => {
        const element = document.getElementById(hash)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 100)
    } else {
      // Si pas d'ancre, scroll en haut de la page
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch (error) {
        // Ignorer l'erreur dans l'environnement de test (jsdom)
      }
    }
  }, [location])

  return null
}

export default ScrollToAnchor
